import { FC } from 'react';
import cx from 'classnames';
import Image from '@components/Image/Image';
import SubscribeForm from '@forms/SubscribeForm/SubscribeForm';

const SubscribeFormModal: FC = () => {
    return (
        <div className={cx('tw-flex tw-justify-center')}>
            <div className="tw-relative tw-hidden tw-bg-red-500 xl:tw-block xl:tw-w-[45%] xl:tw-flex-shrink-0">
                <Image
                    sources={[
                        {
                            srcset: '/wp-content/themes/touchbistro4/images/subscriber-series-modal-reized-768.webp',
                            breakpoint: '576px',
                        },
                        {
                            srcset: '/wp-content/themes/touchbistro4/assets/images/subscriber-series-576.webp',
                            breakpoint: '414px',
                        },
                    ]}
                    src={'/wp-content/themes/touchbistro4/assets/images/subscriber-series-modal-resized-414.webp'}
                    alt={'TouchBistro POS'}
                    className={
                        'tw-absolute tw-left-1/2 tw-top-1/2 tw-min-h-full tw-min-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-object-cover'
                    }
                />
            </div>

            <div className={cx('xl:tw-p-12')}>
                <h2 className={cx('tw-text-center')}>You’re moments away from unlocking restaurant success!</h2>
                <SubscribeForm fieldPrefix={'msub'} />
            </div>
        </div>
    );
};

export default SubscribeFormModal;
